import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function NotFoundPage() {
  // A page that does not exist must not be indexed (the server answers 200 for every address of this single-page site)
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    const previousTitle = document.title;
    document.title = "404 — GozzoGuide";
    return () => {
      meta.remove();
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#09101F] flex flex-col" data-testid="not-found-page">
      <Navbar minimal />

      <main className="flex-1 flex items-center justify-center px-6 py-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl text-center"
        >
          <p
            className="font-body text-[#FF6B00] text-sm tracking-[0.3em] uppercase mb-6"
            data-testid="not-found-label"
          >
            Error · Errore
          </p>

          <h1
            className="font-heading text-7xl sm:text-8xl lg:text-9xl text-white tracking-tight mb-6"
            data-testid="not-found-code"
          >
            404
          </h1>

          <h2
            className="font-heading text-2xl sm:text-3xl text-white mb-8"
            data-testid="not-found-title"
          >
            Pagina non trovata · Page not found
          </h2>

          <p className="font-body text-white/70 text-base md:text-lg mb-3 max-w-xl mx-auto">
            Forse hai sbagliato indirizzo. Torna alla home per esplorare GozzoGuide.
          </p>
          <p className="font-body text-white/50 text-sm md:text-base mb-12 max-w-xl mx-auto italic">
            The page you&apos;re looking for doesn&apos;t exist. Go back to discover GozzoGuide.
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-3 btn-primary text-base md:text-lg px-8 py-4 orange-glow"
            data-testid="not-found-home-btn"
          >
            <Home className="w-5 h-5" />
            <span>Torna alla Home · Back to Home</span>
          </Link>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
